import { FileImageMarkerIcon } from './FileImageMarkerIcon';

/**
 * author: Colton Wiscombe
 * id 5E5F502C-C492-45EC-886C-CC55C6E4C504
 * name file-image-marker
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-image-marker.svg
 * tags
 * - Files / Folders 
 * - Navigation 
 */
export const FileImageLocationIcon = FileImageMarkerIcon;
export default FileImageLocationIcon